import React, {useEffect, useState} from "react";
import Table from "../../components/table/Table";
import Select2 from "../../components/Select2";
import Pagination from "../../components/Pagination";
import {HTTP_ERROR_CODES} from "../../constants/error.js";
import {errorStatusHandle} from "../../utils/error-utils";
import { ROLE_USER, STATUS_USER} from "../../constants/app.js";
import {UserAddModal, ResetPasswordConfirmModal, UserStatusToggle} from '../../components/user-master'
import { getRoleUserOption} from "../../utils/select-utils";
import ConfirmModal from "../../components/ConfirmModal"
import UserMasterLayout from "../../layouts/UserMasterLayout";
import {
  getSelectedValue,
} from "../../utils/select-utils";
import {
  TextInput,
  ButtonTableResetPassword,
  ButtonAdd,
  ButtonUpdate,
  ButtonReset,
  PageTitle,
  CheckboxInput,
  ButtonDPad, RedirectAlert,
} from "../../components";
import {hasErrorBatch} from "../../utils";
import {getUserUpdatePageSettings} from "../../api/setting/userMasterPageApi";
import {
  fetchUsers,
  createUser,
  updateUser,
  resetPassword
} from "../../services/user-master/UserServices";
import {useDispatch} from "react-redux";
import {useDocumentTitle, usePagination, useSort} from "../../hooks";
import {setPageSettings} from "../../store/actions/pageActions";
import getPageBreadcrumb from "../../services/BreadcrumbServices";
import {USER_MASTER_UPDATE} from "../../constants/routes";
import {
  resetAlert,
  setUpdateUserBatchAlertError,
  setAlertSuccess,
  setAlertError,
  refreshNotifications,
  clearPageLoading,
  setButtonProcessing,
  setPageLoading,
  clearButtonProcessing,
} from '../../store/actions';
import PageAlert from '../../components/alerts/PageAlert';
import store from "../../store";
import {
  BUTTON_ADD_USER_UPDATE,
  BUTTON_UPDATE_USER_UPDATE,
} from "../../constants/buttons";
import { handleOnBeforeUnload } from "../../utils/common-utils.js";
import {USER_MASTER_UPDATE_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

function UserUpdatePage() {
  useRedirectPage(USER_MASTER_UPDATE_PAGE);
  const selectOptionsRoleMasterUser = [
    {
      value: ROLE_USER.USER,
      label: "一般ユーザー",
    },
    {
      value: ROLE_USER.MASTER_ADMIN,
      label: "ユーザーマスタ管理者",
    }
  ];

  const selectOptionsRoleSuperUser = getRoleUserOption();

  const auth = store.getState().auth;
  const authRole = auth.user.role;
  const authId = auth.user.id;

  const dispatch = useDispatch();
  const [initialDataSort, setInitialDataSort] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [formUpdateTableData, setFormUpdateTableData] = useState({});
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [userId, setUserId] = useState('');
  const [hasChanged, setHasChanged] = useState(false);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [formErrorAddUser, setFormErrorAddUser] = useState([]);
  const [errorMessagesUpdateUser, setErrorMessagesUpdateUser] = useState([]);
  const [deletedUserIds, setDeletedUserIds] = useState([]);
  const [formCreateUserData, setFormCreateUserData] = useState({
    username: '',
    password: '',
    name: '',
    email: '',
    role: ROLE_USER.USER,
    status: STATUS_USER.ACTIVE,
  });

  //Set user
  useEffect(() => {
    const response = getUserUpdatePageSettings();
    const pageSettings = response.data;
    dispatch(setPageSettings(pageSettings));
    dispatch(setPageLoading());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Set user
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchUsers();
        setTableData(response.data.users);
        setInitialDataSort(response.data.users);
      } catch (error) {
        errorStatusHandle(error);
      } finally {
        dispatch(clearPageLoading());
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  const {currentPage, setCurrentPage, paginatedData, setPaginatedData, pageSize, setPageSize, totalItems} = usePagination(tableData);

  const {sortData, sortOrderList, handleSortColumn} = useSort(initialDataSort);
  useEffect(() => {
    setTableData(sortData)
  }, [sortData]);

  // Check before load page
  useEffect(() => {
    if (!hasChanged) return;

    window.addEventListener('beforeunload', handleOnBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleOnBeforeUnload)
    }
  }, [hasChanged]);

  const checkPermission = (role, userId, userChecking = true) => {
    if (authId === userId && userChecking) {
      return true;
    }
    return authRole > role
  };

  function getSelectOptionRole(role = authRole) {
    if (role === ROLE_USER.SUPER_ADMIN) {
      return selectOptionsRoleSuperUser;
    }

    return selectOptionsRoleMasterUser
  }

  // Submit update table
  const handleSubmitUpdateTable = async (e) => {
    dispatch(resetAlert());
    dispatch(setButtonProcessing(BUTTON_UPDATE_USER_UPDATE));
    if (Object.keys(formUpdateTableData).length > 0 || deletedUserIds.length > 0) {
      e.preventDefault();
      try {
        const response = await updateUser(formUpdateTableData, deletedUserIds);
        dispatch(setAlertSuccess(response.message));
        setErrorMessagesUpdateUser([]);
        setFormUpdateTableData({});
        setDeletedUserIds([]);
        setHasChanged(false);
        setReload((prevReLoad) => !prevReLoad);
      } catch (e) {
        errorStatusHandle(e);
        if (e.status === HTTP_ERROR_CODES.BAD_REQUEST) {
          let responseData = e.data;
          dispatch(setUpdateUserBatchAlertError(responseData));
          setErrorMessagesUpdateUser(responseData.errors);
          setHasChanged(true);
        }
      } finally {
        dispatch(clearButtonProcessing(BUTTON_UPDATE_USER_UPDATE));
      }
    }
  };

  // set data update table
  function setUpdateTableData(value, field, id) {
    setHasChanged(true);
    const updatedUsers = {...formUpdateTableData[id], [field]: value};
    setFormUpdateTableData(prevFormUpdateTableData => ({...prevFormUpdateTableData, [id]: updatedUsers}))
  }

  function handleInputTableChange(index, e, fieldName, id) {
    setUpdateTableData(e.target.value, fieldName, id);

    setPaginatedData((prevPaginatedData) => {
      const updatedTableData = [...prevPaginatedData];
      updatedTableData[index][fieldName] = e.target.value;
      return updatedTableData;
    });
  }

  function handleSelectChange(selectOption, index, fieldName, id) {
    var value = null;
    if (selectOption) {
      value = selectOption.value
    }

    setUpdateTableData(value, fieldName, id);
    setPaginatedData((prevPaginatedData) => {
      const updatedTableData = [...prevPaginatedData];
      updatedTableData[index][fieldName] = value;
      return updatedTableData;
    });
  }

  function handleToggle(index, fieldName, value, id) {
    const formatValue = value ? STATUS_USER.ACTIVE: STATUS_USER.RESIGN;
    setUpdateTableData(formatValue, fieldName, id);

    setPaginatedData((prevPaginatedData) => {
      const updatedTableData = [...prevPaginatedData];
      updatedTableData[index][fieldName] = formatValue;
      return updatedTableData;
    });
  }

  const handleChangeCheckbox = (e, index, fieldName, userId) => {
    setDeletedUserIds(prevIds => e.target.checked ? [...prevIds, userId] : prevIds.filter(id => id !== userId));
    setPaginatedData((prevPaginatedData) => {
      const updatedTableData = [...prevPaginatedData];
      if (e.target.checked) {
        updatedTableData[index][fieldName] = e.target.checked;
      } else {
        delete updatedTableData[index][fieldName]
      }
      return updatedTableData;
    });
  };

  // Submit add new user
  const handleSubmitCreateUser = async (e) => {
    e.preventDefault();
    dispatch(setButtonProcessing(BUTTON_ADD_USER_UPDATE));
    try {
      const response = await createUser(formCreateUserData);
      setTableData(prevTableData => [response.data.users, ...prevTableData]);
      setInitialDataSort(prevTableData => [response.data.users, ...prevTableData]);
      dispatch(setAlertSuccess(response.message));
      resetModalAddUserData();
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === HTTP_ERROR_CODES.BAD_REQUEST) {
        setFormErrorAddUser(e.data)
      }
    } finally {
      dispatch(clearButtonProcessing(BUTTON_ADD_USER_UPDATE));
    }
  };

  // show add user modal
  const handleClickAddModalForm = () => {
    setShowAddUserModal(true);
  };

  const resetModalAddUserData = () => {
    setShowAddUserModal(false);
    setFormErrorAddUser({});
    setFormCreateUserData({
      username: '',
      password: '',
      name: '',
      email: '',
      role: ROLE_USER.USER,
      status: STATUS_USER.ACTIVE,
    })
  };

  // Submit reset password user
  const handleSubmitResetPassword = async (e) => {
    e.preventDefault();
    setShowResetPasswordModal(false);
    try {
      const response = await resetPassword({user_id: userId});
      dispatch(setAlertSuccess(response.message));
      store.dispatch(refreshNotifications(response.notifications));
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === HTTP_ERROR_CODES.BAD_REQUEST) {
        dispatch(setAlertError(e.data.error_message))
      }
    }
  };

  const handleClickResetPassword = (id) => {
    setShowResetPasswordModal(true);
    setUserId(id);
  };

  function resetPage() {
    if (!hasChangeTable()) {
      setHasChanged(false);
      setIsConfirmModalOpen(true)
    } else {
      window.location.reload()
    }
  }

  // Check form table has change
  const hasChangeTable = () => {
    return Object.keys(formUpdateTableData).length === 0 && deletedUserIds.length === 0;
  };

  const breadcrumb = getPageBreadcrumb(USER_MASTER_UPDATE);
  useDocumentTitle("ユーザーマスタ更新");

  return (
    <UserMasterLayout
      breadcrumb={breadcrumb}
    >
      <PageTitle title="ユーザーマスタ更新"/>
      <RedirectAlert />
      <PageAlert/>
      <ButtonDPad />
      <div className="relative inline-block mr-[24px] w-fit">
        <div className='flex items-center'>
          <span className='text-[#F85955]'>(*)</span>
          <span className='ml-[5px]'>必須フィールド</span>
        </div>
        <div className="relative rounded-lg border border-[#e0e0e0]">
          <Table className="no-drop-shadow-table"  striped>
            <Table.Head className="whitespace-nowrap">
              <Table.HeadCell
                className="w-[260px] min-w-[200px]"
                sortable
                order={sortOrderList.username}
                onChangeOrder={() => handleSortColumn("username")}
              >
                <span>ユーザーID</span>
                <span className="ml-[1px] text-[#F85955]">
                *
              </span>
              </Table.HeadCell>
              <Table.HeadCell
                className="w-[200px] min-w-[160px]"
                sortable
                order={sortOrderList.name}
                onChangeOrder={() => handleSortColumn("name")}
              >
                <span>ユーザー名</span>
                <span className="ml-[1px] text-[#F85955]">
                *
                </span>
              </Table.HeadCell>
              <Table.HeadCell
                className="w-[380px] min-w-[240px]"
              >
                <span>メールアドレス</span>
              </Table.HeadCell>
              <Table.HeadCell
                className="w-[240px] min-w-[160px]"
                sortable
                order={sortOrderList.role}
                onChangeOrder={() => handleSortColumn("role")}
              >
                <span>ロール</span>
                <span className="ml-[1px] text-[#F85955]">
                *
                </span>
              </Table.HeadCell>
              <Table.HeadCell
                className="w-[200px] min-w-[120px]"
                onChangeOrder={() => handleSortColumn("status")}
              >
                <span>状態</span>
              </Table.HeadCell>
              <Table.HeadCell
                className="w-[140px] min-w-[80px]"
              >
                <span>パスワード</span>
              </Table.HeadCell>
              <Table.HeadCell
                className="w-[80px] min-w-[80px] text-center"
              >
                <span>削除</span>
              </Table.HeadCell>
            </Table.Head>
            <Table.Body className="devide-y xl:text-base text-[15px] whitespace-nowrap">
              {paginatedData.map((row, index) => (
                  <Table.Row
                    key={index}
                    className={row.delete ? "!bg-[#FFE7E7]" : ""}>
                    <Table.Cell className="2xl:px-[24px] xl:py-[10px] xl:px-[16px] lg:px-[12px] px-[8px] py-[6px]">
                      <TextInput
                        autoFocus={index === 0}
                        className="xl:text-base text-gray-900 w-full px-2.5 py-2 xl:px-3 xl:py-2.5"
                        type="text"
                        name={`user-name-${index}`}
                        maxLength="20"
                        value={row.username || ""}
                        readOnly={checkPermission(row.role, row.id)}
                        onChange={(e) =>
                          handleInputTableChange(index, e, "username", row.id)
                        }
                        hasError={hasErrorBatch(row.id, "username", errorMessagesUpdateUser)}
                      />
                    </Table.Cell>
                    <Table.Cell className="2xl:px-[24px] xl:py-[10px] xl:px-[16px] lg:px-[12px] px-[8px] py-[6px]">
                      <TextInput
                        className="xl:text-base text-gray-900 w-full max-w-[220px] px-2 py-2.5 xl:px-2.5 xl:py-3"
                        type="text"
                        maxLength="40"
                        name={`name-${index}`}
                        value={row.name || ""}
                        readOnly={checkPermission(row.role, row.id, false)}
                        onChange={(e) =>
                          handleInputTableChange(index, e, "name", row.id)
                        }
                        hasError={hasErrorBatch(row.id, "name", errorMessagesUpdateUser)}
                      />
                    </Table.Cell>
                    <Table.Cell className="2xl:px-[24px] xl:py-[10px] xl:px-[16px] lg:px-[12px] px-[8px] py-[6px]">
                      <TextInput
                        className="xl:text-base text-gray-900 w-full px-2 py-2.5 xl:px-2.5 xl:py-3"
                        type="text"
                        maxLength="200"
                        name={`email-${index}`}
                        readOnly={checkPermission(row.role, row.id, false)}
                        value={row.email}
                        onChange={(e) => handleInputTableChange(index, e, "email", row.id)}
                        hasError={hasErrorBatch(row.id, "email", errorMessagesUpdateUser)}
                      />
                    </Table.Cell>
                    <Table.Cell className="2xl:px-[24px] xl:py-[10px] xl:px-[16px] lg:px-[12px] px-[8px] py-[6px]">
                      <Select2
                        options={getSelectOptionRole()}
                        className="xl:text-base text-gray-900"
                        classNamePrefix="react-select"
                        maxLength={15}
                        value={getSelectedValue(getSelectOptionRole(row.role), row.role)}
                        isDisabled={checkPermission(row.role, row.id)}
                        placeholder=''
                        onChange={(getSelectOptionRole) => handleSelectChange(getSelectOptionRole, index, "role", row.id)}
                        name={`role-` + row.id}
                        hasError={hasErrorBatch(row.id, "role", errorMessagesUpdateUser)}
                      />
                    </Table.Cell>
                    <Table.Cell className="2xl:px-[24px] xl:py-[10px] xl:px-[16px] lg:px-[12px] px-[8px] py-[6px]">
                      <UserStatusToggle checked={row.status} disabled={checkPermission(row.role, row.id)}
                        handleChangeToggle={handleToggle} index={index} id={row.id} />
                    </Table.Cell>
                    <Table.Cell className="flex item-center justify-center">
                      <ButtonTableResetPassword disabled={checkPermission(row.role, row.id, false)} onClick={() => handleClickResetPassword(row.id)} />
                    </Table.Cell>
                    <Table.Cell>
                      <CheckboxInput
                        position="justify-center"
                        name="delete"
                        checked={row.delete}
                        disabled={checkPermission(row.role, row.id)}
                        onChange={(e) =>
                          handleChangeCheckbox(e, index, "delete", row.id)
                        }
                        value={row.delete}
                      />
                    </Table.Cell>
                  </Table.Row>
                )
              )}
            </Table.Body>
          </Table>
        </div>
        <div className="lg:flex items-center mt-4">
          <ButtonAdd type="submit" onClick={handleClickAddModalForm} className="mr-[20px]">
            追加
          </ButtonAdd>
          <div className="w-full lg:mt-0 mt-[8px]">
            <Pagination
              setPage={setCurrentPage}
              currentPage={currentPage}
              setPageSize={setPageSize}
              pageSize={pageSize}
              totalCount={totalItems}
              CustomStyles=""
            />
          </div>
        </div>
        <div className="flex mt-6 xl:py-2.5 py-1.5 w-full justify-center xl:space-x-[80px] space-x-[40px]">
          <ButtonReset className="min-w-[200px] lg:min-w-[280px]" onClick={resetPage} />
          <ButtonUpdate disabled={hasChangeTable()} className="min-w-[200px] lg:min-w-[280px]" id={BUTTON_UPDATE_USER_UPDATE} onClick={(e) => handleSubmitUpdateTable(e)}>
            適用
          </ButtonUpdate>
        </div>
      </div>
      <ResetPasswordConfirmModal
        openModal={showResetPasswordModal}
        setOpenModal={setShowResetPasswordModal}
        onConfirm={(e) => handleSubmitResetPassword(e)}
      />
      <UserAddModal
        showModal={showAddUserModal}
        setShowModal={setShowAddUserModal}
        selectOptionRole={getSelectOptionRole(authRole)}
        formCreateUserData={formCreateUserData}
        setFormCreateUserData={setFormCreateUserData}
        formError={formErrorAddUser}
        buttonId={BUTTON_ADD_USER_UPDATE}
        handleSubmit={(e) => handleSubmitCreateUser(e)}
      />
      <ConfirmModal openModal={isConfirmModalOpen} setOpenModal={setIsConfirmModalOpen} onConfirm={() => window.location.reload()} setHasChanged={setHasChanged}/>
    </UserMasterLayout>
  );
}

export default UserUpdatePage;

